import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector"
import type { CustomDetector } from "i18next-browser-languagedetector"
import { detectInitialLanguage } from "./detectInitialLanguage"
import messages, { i18nNamespaces } from "./local/index"

const browserLocaleRuEnDetector: CustomDetector = {
  name: "browserLocaleRuEn",
  lookup() {
    return detectInitialLanguage()
  },
}

const languageDetector = new I18nextBrowserLanguageDetector()
languageDetector.addDetector(browserLocaleRuEnDetector)

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ru", "en"],
    fallbackLng: "ru",
    ns: [...i18nNamespaces],
    defaultNS: "translation",
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "browserLocaleRuEn"],
      caches: ["localStorage"],
      lookupLocalStorage: "nbr_web_locale",
    },
  })

export default i18n
